export default __webpack_public_path__ + "static/media/channelBannerDemo.14dd6ce2.png";